import { CSSProperties } from "react";

const Loader = ({
    size = 24,
    color,
}: {
    size?: number;
    color?: string;
}) => {
  return (
    <span 
        className="animate-spin border-2 border-gray3/80 !border-b-transparent rounded-full inline-block"
        style={{
            width: size,
            height: size,
            ...(color && { borderColor: color })
        }}
    ></span>
  );
}

export default Loader;